module.exports = __webpack_public_path__ + "static/img/banner-csr-06.1d7b412.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-06.jpg
// module id = RxwL
// module chunks = 98